import { useToast } from 'vue-toastification'
import type { PluginOptions } from 'vue-toastification'

type ToastType = 'success' | 'error' | 'info' | 'warning'

interface ToastOptions extends Partial<PluginOptions> {
  toastClassName?: string
}

export function showToast(type: ToastType, msg: string, options: ToastOptions = {}): void {
  const toast = useToast()

  const config: Record<ToastType, { style: string; timeout: number }> = {
    success: {
      style: 'bg-emerald-500 border border-emerald-300 text-white',
      timeout: 5000,
    },
    error: {
      style: 'bg-red-500 border border-red-300 text-white',
      timeout: 9000,
    },
    info: {
      style: 'bg-sky-500 border border-sky-300 text-white',
      timeout: 9000,
    },
    warning: {
      style: 'bg-amber-500 border border-amber-300 text-white',
      timeout: 9000,
    },
  }

  const { style, timeout } = config[type]
  const resolvedOptions: ToastOptions = {
    ...options,
    timeout: options.timeout ?? timeout,
    toastClassName: `${options.toastClassName ?? ''} ${style}`.trim(),
  }

  toast[type](msg, resolvedOptions)
}
